import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  selector: 'app-fn-search-input',
  templateUrl: './fn-search-input.component.html',
  styleUrls: ['./fn-search-input.component.scss'],
})
export class FnSearchInputComponent {
  @Output() onSearch = new EventEmitter<string>();
  @Input() searchValue: string = '';

  constructor(private translate: TranslateService) {}

  
}
